export default {
  index: '首页',
  summary: '申请概要',
  studentQuery: '学生查询',
  applicationList: '申请列表',
  studentManagement: '代理学生管理',
  studentRegister: '新增学生',
  studentInfo: '学生个人信息',
  studentInfoManagement: '学生资料管理',
  studentApplicationForm: '学生申请汇总',
  commissionManagement: '佣金管理',
  informationCenter: '资讯中心',
  newsInfo: '新闻资讯',
  institutionInfo: '院校资讯',
  institutionInformationDetail: '院校资讯详情',
  videoCenter: '视频中心',
  newsInfoEntrance: '新闻资讯入口',
  newsInfoDetail: '新闻资讯详情',
  quickViewMPS: '快速查看Commission',

  businessOverview: '业务总览',
  businessStatistics: '业务统计',
  financialSettlement: '财务结算',
  mpsManagement: '院校佣金',
  resourceManagement: '院校资源',
  applicationFee: '院校资源信息',
  languageReq: '接受的语言类型',
  companySetting: '公司设置',
  setting: '设置',
  studentInformation: '学生专页',
  contactPerson: '联系负责人',
  // studentApplicationForm: '课程申请',
};
